
<template>
    <div id="divMap" style="height: 100%; width: 100%">
        <!-- 添加定位地图弹出框    -->
        <div id="clickPop">
            <comClickPop
                :clickDataPopInfo="clickDataPopInfo"
                @closeClickPop="closeClickPop"
            ></comClickPop>
        </div>
    </div>
</template>
<script>
import {
    fullScreenStartLoading,
    fullScreenEndLoading,
} from '@/V3/js/loading.js'
import { initMap, changeBaseLayer, addWfsLayer } from '@/V3/js/map.js'
import { line_style, plane_style, point_style } from '@/V3/js/mapStyle.js'
import comClickPop from '@/V3/Main/ExportData/comClickPop'

import 'ol/ol.css'
import { Map, View, Overlay } from 'ol'

import VectorSource from 'ol/source/Vector'
import GeoJSONFormat from 'ol/format/GeoJSON'

import VectorLayer from 'ol/layer/Vector'
import { transform, transformExtent, fromLonLat } from 'ol/proj'
import { OSM, TileWMS, Vector } from 'ol/source'

import Draw from 'ol/interaction/Draw'
import { unByKey } from 'ol/Observable.js'
import { WFS, GeoJSON } from 'ol/format'
import { MultiLineString, Point } from 'ol/geom'
import { Circle, Stroke, Style, Fill, Icon, Text } from 'ol/style'

import Feature from 'ol/Feature'
import {
    and as andFilter,
    equalTo as equalToFilter,
    like as likeFilter,
} from 'ol/format/filter'
import axios from 'axios'
import { Modify, Snap, Select } from 'ol/interaction'

import { toLonLat } from 'ol/proj'
import { toStringHDMS } from 'ol/coordinate'

import eventBus from '@/V3/js/eventBus'

export default {
    data() {
        return {
            tName: '',
            // OpenLayers Map对象
            map: {},
            centerLonLat: [101, 37.8],
            zoomLevel: 7,
            // 当前页待审核图层
            currentPagePassLayer: {},
            //clickPop 审核弹出框
            clickPop: {},
            clickDataPopInfo: {
                censusenum: null,
                check_reas: null,
                check_stat: null,
                coor_x: null,
                coor_y: null,
                distance: null,
                excursus: null,
                fid_: null,
                household: null,
                id: null,
                input_reas: null,
                input_time: null,
                input_work: null,
                lev2: null,
                lev2_name: null,
                lev3: null,
                location: null,
                location_1: null,
                location_s: null,
                n_position: null,
                name: null,
                other: null,
                population: null,
                remark: null,
                tlocation: null,
                user: null,
            },
            // 当前矢量点
            highLightFeature: {},
        }
    },
    components: {
        comClickPop,
    },
    mounted() {
        this.gettName()
        this.map = initMap('divMap', this.centerLonLat, this.zoomLevel)
        changeBaseLayer(this.map, 'image')
        this.addStaticLayer1()
        //
        this.refresh(
            0,
            10,
            'coor_x>0 and coor_y >0 and location_1=1 and check_stat=1'
        )
        eventBus.on('pageTurn', (value) => {
            this.refresh(value.startIndex, value.size, value.CQL_FILTER)
        })
        eventBus.on('viewPassJuLuo', (value) => {
            // 查看定位
            this.viewPassJuLuo(value)
        })
        this.initclickPop()
    },
    created() {},
    methods: {
        // dateFormat
        dateFormat(format) {
            var date = new Date()
            var format_arr = {
                Y: date.getFullYear(),
                m:
                    date.getMonth() + 1 >= 10
                        ? date.getMonth() + 1
                        : '0' + (date.getMonth() + 1),
                d: date.getDate() >= 10 ? date.getDate() : '0' + date.getDate(),
                H:
                    date.getHours() >= 10
                        ? date.getHours()
                        : '0' + date.getHours(),
                i:
                    date.getMinutes() >= 10
                        ? date.getMinutes()
                        : '0' + date.getMinutes(),
                s:
                    date.getSeconds() >= 10
                        ? date.getSeconds()
                        : '0' + getSeconds(),
            }
            for (var key in format_arr) {
                format = format.replace(key, format_arr[key])
            }
            return format
        },
        //gettName() // 当前系统用户名真实姓名
        gettName() {
            axios({
                url: $webConfig.V3.backendAPI + 'getUsertName',
                method: 'post',
                data: JSON.stringify({
                    mail: this.getUser(),
                }),
            }).then((res) => {
                if (res.data.tName) {
                    this.tName = res.data.tName
                } else {
                    this.tName = ''
                }
            })
        },
        // getUser() // 当前系统用户名
        getUser() {
            if (this.$cookie.get('mail') == null) {
                return this.$store.state.V3mail
            } else {
                return this.$cookie.get('mail')
            }
        },
        // 初始化审核弹出框
        initclickPop() {
            var container = document.getElementById('clickPop')
            this.clickPop = new Overlay({
                element: container,
                autoPan: true,
                offset: [0, -10],
                positioning: 'bottom-center',
                stopEvent: true,
                autoPanAnimation: { duration: 250 },
            })
            this.map.addOverlay(this.clickPop)
            this.clickPop.setPosition(undefined)
        },
        // closeClickPop
        closeClickPop() {
            // 恢复上次点击要素的符号
            let self = this
            if (self.highLightFeature != undefined) {
                if (self.highLightFeature.setStyle != undefined) {
                    self.highLightFeature.setStyle('')
                }
            }
            this.clickPop.setPosition(undefined)
        },
          addStaticLayer1(){
            let my_line_style = new line_style('')
            let my_plane_style = new plane_style()
            let my_point_style = new point_style('')

            // 缩放到县图层
            let zoomToCountyLayerUrl =
                $webConfig.V3.owsBaseURL +
                '?service=WFS&version=1.0.0&request=GetFeature&typeName=lwdgis:gcounty&outputFormat=application/json'

            let zoomToCountyStyle = my_plane_style.prefecture_seat_tranparent
            this.zoomToCountyLayer = addWfsLayer(
                zoomToCountyLayerUrl,
                zoomToCountyStyle,
                '缩放到县图层',
                8
            )
            this.map.addLayer(this.zoomToCountyLayer)
                   // //加载现代甘肃省市级政区边界
            let county_now_wfs_url =
                $webConfig.V3.owsBaseURL +
                '?service=WFS&version=1.0.0&request=GetFeature&typeName=lwdgis:gmodernline&outputFormat=application/json'

            let county_now_wfs_style = my_line_style.gmodern
            let county_now_layer = addWfsLayer(
                county_now_wfs_url,
                county_now_wfs_style,
                '现代甘肃省级边界',
                5
            )
            this.map.addLayer(county_now_layer)
            // 加载1911年甘肃县政区边界
            let county_old_wfs_url2 =
                $webConfig.V3.owsBaseURL +
                '?service=WFS&version=1.0.0&request=GetFeature&typeName=lwdgis:gline3&outputFormat=application/json'

            let county_old_wfs_style2 = my_line_style.county_old2
            let county_old_layer2 = addWfsLayer(
                county_old_wfs_url2,
                county_old_wfs_style2,
                '1911年甘肃县级边界',
                5
            )
            this.map.addLayer(county_old_layer2)
                    //加载1911年甘肃市政区边界
            let county_old_wfs_url1 =
                $webConfig.V3.owsBaseURL +
                '?service=WFS&version=1.0.0&request=GetFeature&typeName=lwdgis:gline2&outputFormat=application/json'

            let county_old_wfs_style1 = my_line_style.county_old1
            let county_old_layer1 = addWfsLayer(
                county_old_wfs_url1,
                county_old_wfs_style1,
                '1911年甘肃府级边界',
                5
            )
           this.map.addLayer(county_old_layer1)
          //加载1911年甘肃省政区边界
            let county_old_wfs_url =
                $webConfig.V3.owsBaseURL +
                '?service=WFS&version=1.0.0&request=GetFeature&typeName=lwdgis:gline1&outputFormat=application/json'

            let county_old_wfs_style = my_line_style.county_old
            let county_old_layer = addWfsLayer(
                county_old_wfs_url,
                county_old_wfs_style,
                '1911年甘肃省级边界',
                5
            )
            this.map.addLayer(county_old_layer)
    
     
            // 加载1911年县级政区治所
            let county_seat_wfs_url =
                $webConfig.V3.owsBaseURL +
                '?service=WFS&version=1.0.0&request=GetFeature&typeName=lwdgis:gpoint3&outputFormat=application/json'

            // let county_seat_wfs_style = function (feature, resolution) {
            //     let text = ''
            //     if (resolution > 2319) {
            //         text = ''
            //     } else {
            //         text = feature.getProperties().NAME_CH
            //     }

            //     let style = new point_style(text)

            //     return style.county_seat_label
            // }
            let county_seat_wfs_style = my_point_style.county_seat_label
            this.county_seat_layer = addWfsLayer(
                county_seat_wfs_url,
                county_seat_wfs_style,
                '1911年甘肃县级治所',
                5
            )
            this.map.addLayer(this.county_seat_layer)
            // 加载1911年府级政区治所
            let county_seat_wfs_url1 =
                $webConfig.V3.owsBaseURL +
                '?service=WFS&version=1.0.0&request=GetFeature&typeName=lwdgis:gpoint2&outputFormat=application/json'

            // let county_seat_wfs_style = function (feature, resolution) {
            //     let text = ''
            //     if (resolution > 2319) {
            //         text = ''
            //     } else {
            //         text = feature.getProperties().NAME_CH
            //     }

            //     let style = new point_style(text)

            //     return style.county_seat_label
            // }
            let county_seat_wfs_style1 = my_point_style.county_seat_label1
            this.county_seat_layer1 = addWfsLayer(
                county_seat_wfs_url1,
                county_seat_wfs_style1,
                '1911年甘肃府级治所',
                5
            )
            this.map.addLayer(this.county_seat_layer1)
            //加载1911年省级政区治所
            let province_seat_wfs_url =
                $webConfig.V3.owsBaseURL +
                '?service=WFS&version=1.0.0&request=GetFeature&typeName=lwdgis:gpoint1&outputFormat=application/json'
            let province_seat_wfs_style = my_point_style.province_seat
            this.prefecture_seat_layer = addWfsLayer(
                province_seat_wfs_url,
                province_seat_wfs_style,
                '1911年甘肃省级治所',
                5
            )
            this.map.addLayer(this.prefecture_seat_layer)

         
        },
        // 加载静态图层
        addStaticLayer() {
            let my_line_style = new line_style('')
            let my_plane_style = new plane_style()
            let my_point_style = new point_style('')

            //加载1911年甘肃省政区边界
            let county_old_wfs_url =
                $webConfig.V3.owsBaseURL +
                '?service=WFS&version=1.0.0&request=GetFeature&typeName=lwdgis:gansu_county_old&outputFormat=application/json'

            let county_old_wfs_style = my_line_style.county_old
            let county_old_layer = addWfsLayer(
                county_old_wfs_url,
                county_old_wfs_style,
                '1911年甘肃省政区边界',
                20
            )
            this.map.addLayer(county_old_layer)

            //加载现代甘肃省市级政区边界
            let county_now_wfs_url =
                $webConfig.V3.owsBaseURL +
                '?service=WFS&version=1.0.0&request=GetFeature&typeName=lwdgis:620000_full&outputFormat=application/json'

            let county_now_wfs_style = my_plane_style.county_now
            let county_now_layer = addWfsLayer(
                county_now_wfs_url,
                county_now_wfs_style,
                '现代甘肃省市级政区边界',
                9
            )
            this.map.addLayer(county_now_layer)
            //加载1911年省级政区治所
            let province_seat_wfs_url =
                $webConfig.V3.owsBaseURL +
                '?service=WFS&version=1.0.0&request=GetFeature&typeName=lwdgis:province_seat_1911&outputFormat=application/json'
            let province_seat_wfs_style = my_point_style.province_seat
            this.prefecture_seat_layer = addWfsLayer(
                province_seat_wfs_url,
                province_seat_wfs_style,
                '1911年省级政区治所',
                1
            )
            // 加载1911年县级政区治所
            this.map.addLayer(this.prefecture_seat_layer)
            let county_seat_wfs_url =
                $webConfig.V3.owsBaseURL +
                '?service=WFS&version=1.0.0&request=GetFeature&typeName=lwdgis:gs_county_seat_1911&outputFormat=application/json'

            // let county_seat_wfs_style = function (feature, resolution) {
            //     let text = ''
            //     if (resolution > 2319) {
            //         text = ''
            //     } else {
            //         text = feature.getProperties().NAME_CH
            //     }

            //     let style = new point_style(text)

            //     return style.county_seat_label
            // }
            let county_seat_wfs_style = my_point_style.county_seat_label
            this.county_seat_layer = addWfsLayer(
                county_seat_wfs_url,
                county_seat_wfs_style,
                '1911年县级政区治所',
                1
            )
            this.map.addLayer(this.county_seat_layer)
        },
        // 刷新图层 和左侧表格当前页数据做联动
        refresh(startIndex, size, CQL_FILTER) {
            this.map.removeLayer(this.currentPagePassLayer)
            let url_params = {
                service: 'WFS',
                version: '1.0.0',
                request: 'GetFeature',
                typeName: 'lwdgis:v3data',
                outputFormat: 'application/json',
                sortBy: 'id',
                startIndex: startIndex,
                maxFeatures: size,
                CQL_FILTER: CQL_FILTER,
            }
            let self = this
            let vtSource = new VectorSource({
                format: new GeoJSONFormat({
                    // geometryName: 'geom' // 因为数据源里面字段the_geom存储的是geometry，所以需要指定
                }),
                loader: function (extent, resolution, projection) {
                    axios({
                        url: $webConfig.V3.owsBaseURL,
                        method: 'get',
                        params: url_params,
                    }).then((res) => {
                        var featureList = vtSource
                            .getFormat()
                            .readFeatures(res.data)
                        featureList.forEach((item, index) => {
                            item.setGeometry(
                                item
                                    .getGeometry()
                                    .transform('EPSG:4326', 'EPSG:3857')
                            )
                            vtSource.addFeature(item)
                        })
                    })
                },
            })

            let wfsVectorSource = vtSource
            let my_point_style = new point_style('')

            let pointStyle = function (feature, resolution) {
                let text = ''
                if (resolution > 2319) {
                    text = ''
                } else {
                    text = feature.getProperties().name
                }

                my_point_style.default.getText().setText(text)
                return my_point_style.default
            }

            this.currentPagePassLayer = new VectorLayer({
                source: wfsVectorSource,
                style: pointStyle,
                title: '当前页待审核图层',
                zIndex: 999,
            })

            this.map.addLayer(this.currentPagePassLayer)
        },
        // 已审核 查看定位
        viewPassJuLuo(value) {
            // 恢复上次点击要素的符号
            let self = this
            if (self.highLightFeature != undefined) {
                if (self.highLightFeature.setStyle != undefined) {
                    self.highLightFeature.setStyle('')
                }
            }

            this.currentPagePassLayer
                .getSource()
                .getFeatures()
                .forEach((feature) => {
                    let property = feature.getProperties()

                    if (property.id == value.id) {
                        //为选中的Point 添加样式
                        this.highLightFeature = feature
                        let my_point_style = new point_style(
                            feature.getProperties().name
                        )
                        this.highLightFeature.setStyle(my_point_style.highlight)

                        this.clickDataPopInfo = property
                        let centerLontat = [
                            feature.getGeometry().getExtent()[0],
                            feature.getGeometry().getExtent()[1],
                        ]
                        this.clickPop.setPosition(centerLontat)
                        this.map
                            .getView()
                            .setCenter([
                                centerLontat[0],
                                centerLontat[1] + 180000,
                            ])
                        this.map.getView().setZoom(7.5)
                    }
                })
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/V3/Main/ExportData/comRightMap.vue